import React from 'react'

import { trackedClick } from '../../utils'
import Logo from './Logo'
import ButtonToConsole from './ButtonToConsole'

const rootOpenNavClass = 'is-nav-open'

function toggleNavOpen() {
    const doc = document.querySelector('html')
    if (doc.classList.contains(rootOpenNavClass)) {
        doc.classList.remove(rootOpenNavClass)
    } else {
        doc.classList.add(rootOpenNavClass)
    }
}

const Anchor = ({ title, href, target }) => (
    <li className="header__nav-item" key={title}>
        <a
            tabIndex="0"
            className="header__nav-link"
            onClick={trackedClick(`Header link clicked`, {
                source: 'Header',
                title,
            })}
            href={href}
            title={title}
            target={target}
        >
            {title}
        </a>
    </li>
)

const Header = () => (
    <header className="header">
        <div className="header__container container">
            <div className="header__left">
                <div className="header__logo">
                    <a
                        href={
                            global.CLIENT_HOST || process.env.CLIENT_HOST || ''
                        }
                        onClick={trackedClick('Logo clicked', {
                            source: 'Header',
                            title: 'Logo',
                        })}
                    >
                        <Logo />
                    </a>
                </div>
            </div>
            <div className="header__right">
                <button className="header__burger" onClick={toggleNavOpen}>
                    <span className="header__burger-icon" />
                    <span className="header__burger-text">Menu</span>
                </button>
                <nav className="header__nav">
                    <div className="header__nav-inner">
                        <ul className="header__nav-list">
                            <Anchor
                                title="MT Hub"
                                href="/machine-translation-hub/"
                            />
                            <Anchor title="About" href="/about-intento/" />
                            <Anchor
                                title="API docs"
                                target="_blank"
                                href="https://github.com/intento/intento-api"
                            />
                            <ButtonToConsole />
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    </header>
)

export default Header



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/Header/index.jsx